module.exports = __webpack_public_path__ + "static/media/phone.9171708d.svg";